

















import { defineComponent } from '@vue/composition-api';
import TtamScheduleTimezone from '../timezone/index.vue';
import { PropType } from 'vue';
import { TimeZone } from '../types';

const name = 'ttam-schedule-timezone-desc';

export default defineComponent({
  name,
  props: {
    timezone: {
      type: String,
    },
    timezoneList: {
      type: Array as PropType<TimeZone[]>,
    },
    locationCount: {
      type: Number,
      default: 0,
    },
  },
  components: {
    TtamScheduleTimezone,
  },
  setup(props, { emit }) {
    const onClickCheckNow = () => {
      emit('click');
    };

    return {
      name,
      onClickCheckNow,
    };
  },
});
